<!-- ✅ Logged-in layout -->
<div class="loggedIn" *ngIf="!isLoginRoute; else loggedOut">
  <div class="h-screen w-full bg-slate-100 flex overflow-hidden loggedInContent">

    <!-- SIDEBAR -->
    <aside class="h-full bg-slate-900 text-slate-200 flex flex-col border-r border-slate-800
             transition-all duration-200 sidebar" [class.w-64]="sidebarExpanded" [class.w-20]="!sidebarExpanded"
      (mouseenter)="onSidebarEnter()" (mouseleave)="onSidebarLeave()">

      <!-- Brand -->
      <!-- Brand -->
      <div class="h-16 flex items-center justify-between px-4 border-slate-800">
        <div class="flex items-center gap-2 min-w-0 mt-3">

          <!-- Favicon: only when collapsed and NOT hover-expanded -->
          <div class="rounded-xl d-flex align-items-center justify-content-center" *ngIf="collapsed && !hoverExpanded">
            <img src="../assets/img/aios-fav.svg" class="w-12" />
          </div>

          <!-- Full logo: when expanded OR hover-expanded -->
          <div class="truncate" *ngIf="sidebarExpanded">
            <img src="../assets/img/aios.svg" class="h-12" />
          </div>

        </div>
      </div>

      <!-- NAV -->
      <nav class="flex-1 py-3 overflow-auto">
        <ng-container *ngFor="let item of menu">

          <!-- TOP-LEVEL ITEM WITH CHILDREN -->
          <button *ngIf="item.children?.length" type="button"
            class="group relative nav-item w-[calc(100%-1rem)] mx-2 my-1 flex items-center gap-3 rounded-xl px-3 pyc-2 text-sm text-slate-200 nav-hover transition"
            [class.nav-active]="isItemActive(item)" [class.parent-active]="isItemActive(item)"
            (click)="toggleGroup(item.id)">

            <span class="absolute left-0 top-1/2 -translate-y-1/2 h-7 w-1 rounded-r"
              [class.bg-cyan-500]="isItemActive(item)" [class.bg-transparent]="!isItemActive(item)"></span>

            <span class="w-6 h-8 flex items-center justify-center rounded-xl">
              <img [src]="getItemIcon(item)" alt="" class="h-4 w-4 object-contain" />
            </span>

            <span class="flex-1 truncate text-left" *ngIf="sidebarExpanded">
              {{ item.label }}
            </span>

            <i *ngIf="sidebarExpanded" class="fa fa-angle-down fa-lg text-xs transition-transform submenu-arrow"
              [class.rotate-180]="isGroupOpen(item.id)"></i>
          </button>

          <!-- RECURSIVE SUBMENU TREE -->
          <div *ngIf="item.children?.length && sidebarExpanded && isGroupOpen(item.id)"
            class="mx-2 mb-2 mt-1 rounded-lg bg-slate-950/50 border-slate-800/50 overflow-hidden submenu-wrapper">

            <ng-container *ngTemplateOutlet="nestedMenu; context: { $implicit: item.children, level: 1 }">
            </ng-container>
          </div>

          <!-- TOP-LEVEL SIMPLE ITEM -->
          <a *ngIf="!item.children?.length && item.route" [routerLink]="item.route"
            class="group relative nav-item w-[calc(100%-1rem)] mx-2 my-1 flex items-center gap-3 rounded-xl px-3 pyc-2 text-sm text-slate-200 nav-hover transition"
            [class.nav-active]="isItemActive(item)" (click)="onSimpleMenuClick()">

            <span class="absolute left-0 top-1/2 -translate-y-1/2 h-7 w-1 rounded-r"
              [class.bg-cyan-500]="isItemActive(item)" [class.bg-transparent]="!isItemActive(item)"></span>

            <span class="w-6 h-8 flex items-center justify-center rounded-xl">
              <img [src]="getItemIcon(item)" alt="" class="h-4 w-4 object-contain" />
            </span>

            <span class="flex-1 truncate" *ngIf="sidebarExpanded">
              {{ item.label }}
            </span>
          </a>

        </ng-container>
      </nav>

      <!-- Supports any submenu depth returned by the API. -->
      <ng-template #nestedMenu let-items let-level="level">
        <ng-container *ngFor="let child of items">

          <!-- NESTED ITEM WITH CHILDREN -->
          <div *ngIf="child.children?.length" class="nested-menu-group">

            <!--
              The entire nested-parent row is clickable, exactly like a
              top-level parent. Opening the row can still navigate to the
              parent's own route; closing it does not trigger navigation.
            -->
            <button type="button" class="nested-menu-row transition text-left"
              [class.child-active]="isItemActive(child)" [attr.aria-expanded]="isGroupOpen(child.id)"
              [attr.aria-label]="isGroupOpen(child.id) ? 'Collapse ' + child.label : 'Expand ' + child.label"
              (click)="onNestedParentClick(child, $event)">

              <span
                class="submenu-link nested-menu-parent-link flex-1 flex items-center gap-3 py-2 pr-2 text-sm transition"
                [style.padding-left.px]="16 + ((level - 1) * 14)">

                <span class="submenu-icon-wrap">
                  <img *ngIf="child.lightIcon || child.darkIcon" [src]="getChildIcon(child)" alt=""
                    class="submenu-icon" />
                  <span *ngIf="!child.lightIcon && !child.darkIcon" class="submenu-dot">•</span>
                </span>

                <span class="truncate">{{ child.label }}</span>
              </span>

              <span class="submenu-toggle-btn" aria-hidden="true">
                <i class="fa fa-angle-down text-xs transition-transform submenu-arrow"
                  [class.rotate-180]="isGroupOpen(child.id)"></i>
              </span>
            </button>

            <div *ngIf="sidebarExpanded && isGroupOpen(child.id)" class="nested-submenu-children">
              <ng-container *ngTemplateOutlet="nestedMenu; context: { $implicit: child.children, level: level + 1 }">
              </ng-container>
            </div>
          </div>

          <!-- NESTED LEAF ITEM -->
          <a *ngIf="!child.children?.length && child.route" [routerLink]="child.route"
            class="submenu-link nested-leaf-link flex items-center gap-3 py-2 pr-4 text-sm transition"
            [style.padding-left.px]="16 + ((level - 1) * 14)" [class.child-active]="isRouteActive(child.route)"
            (click)="onNestedMenuLinkClick()">

            <span class="submenu-icon-wrap">
              <img *ngIf="child.lightIcon || child.darkIcon" [src]="getChildIcon(child)" alt="" class="submenu-icon" />
              <span *ngIf="!child.lightIcon && !child.darkIcon" class="submenu-dot">•</span>
            </span>

            <span class="truncate">{{ child.label }}</span>
          </a>

        </ng-container>
      </ng-template>
    </aside>

    <!-- MAIN -->
    <section class="flex-1 min-w-0 h-full flex flex-col bg-slate-100">

      <!-- TOPBAR -->
      <div class="pl-4 pb-4 pt-1 pr-2">
        <header class="h-16 bg-white rounded-lg border border-slate-200/70 flex items-center pr-4 pl-3">
          <button class="rounded-2xl hover:bg-blue-100 flex items-center justify-center p-2 mr-2"
            (click)="toggleSidebar()" [attr.aria-label]="collapsed ? 'Expand sidebar' : 'Collapse sidebar'">
            <i class="fa fa-lg" [class.fa-angle-double-left]="!collapsed" [class.fa-angle-double-right]="collapsed"></i>
          </button>

          <div class="flex items-center gap-4 min-w-0 flex-1">
            <div class="relative w-[420px] max-w-full">
              <input
                class="w-full h-10 rounded-full border border-slate-200 bg-slate-50 pl-10 pr-3 text-sm outline-none focus:ring-2 focus:ring-slate-200"
                placeholder="Quick Search..." />
              <i class="fa fa-search absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"></i>
            </div>
          </div>

          <!-- right controls -->
          <div class="flex items-center gap-2">

            <div class="relative mr-0" #notifWrap>
              <button type="button"
                class="h-10 w-10 rounded-full hover:bg-slate-100 flex items-center justify-center relative"
                (click)="toggleNotifications($event)" aria-haspopup="true" [attr.aria-expanded]="isNotificationsOpen">
                <i class="fa fa-bell fa-lg"></i>
                <span class="absolute top-2 right-2 h-2 w-2 rounded-full bg-red-500"></span>
              </button>

              <div *ngIf="isNotificationsOpen"
                class="absolute right-0 mt-2 w-80 rounded-xl bg-white border border-slate-200 z-50 shadow-soft">

                <header class="px-3 py-2.5 border-b border-slate-200 flex items-center justify-between">
                  <h6 class="text-[13px] font-semibold text-slate-900 m-0">Notifications</h6>
                  <span class="text-[11px] font-semibold px-2 py-0.5 rounded bg-emerald-50 text-emerald-700">
                    7 Notifications
                  </span>
                </header>

                <ul class="max-h-80 overflow-auto divide-y divide-slate-100 pl-1">
                  <li class="px-3 py-2.5 hover:bg-slate-50 cursor-pointer">
                    <div class="flex gap-2.5">
                      <div class="notification-icon-bg">
                        <i class="fa fa-bell"></i>
                      </div>
                      <div class="min-w-0">
                        <p class="text-[12px] font-semibold text-slate-900 leading-4 mb-0 truncate">
                          Emily Johnson
                        </p>
                        <p class="text-[11px] text-slate-600 leading-4 mb-0">
                          commented on a task in <span class="font-medium">Design Sprint</span>
                        </p>
                        <time class="text-[10px] text-slate-400">12 minutes ago</time>
                      </div>
                    </div>
                  </li>

                  <li class="px-3 py-2.5 hover:bg-slate-50 cursor-pointer">
                    <div class="flex gap-2.5">
                      <div class="notification-icon-bg">
                        <i class="fa fa-bell"></i>
                      </div>
                      <div class="min-w-0">
                        <p class="text-[12px] font-semibold text-slate-900 leading-4 mb-0 truncate">
                          Michael Lee
                        </p>
                        <p class="text-[11px] text-slate-600 leading-4 mb-0">
                          uploaded files to <span class="font-medium">Marketing Assets</span>
                        </p>
                        <time class="text-[10px] text-slate-400">25 minutes ago</time>
                      </div>
                    </div>
                  </li>
                </ul>

                <footer class="px-3 py-2 border-t border-slate-200">
                  <button type="button" class="w-full text-[12px] font-semibold text-blue-600 hover:underline">
                    Read All Messages
                  </button>
                </footer>
              </div>
            </div>

            <div class="mr-3 d-flex align-items-center">
              <button type="button" class="h-10 w-10 rounded-full hover:bg-slate-100 flex items-center justify-center"
                (click)="toggleFullscreen()" [attr.aria-label]="isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'">
                <i class="ti text-[20px]" [class.ti-maximize]="!isFullscreen" [class.ti-minimize]="isFullscreen"></i>
              </button>
            </div>

            <div id="profileDropdown" class="relative flex items-center gap-2">
              <div class="bg-slate-200 rounded-full img-border">
                <img [src]="headerProfileImage" class="h-9 w-9 rounded-full object-cover" alt="Profile" />
              </div>

              <div class="relative">
                <button type="button" (click)="toggleProfile()" class="flex gap-2 hover:opacity-90 transition">
                  <div class="hidden sm:block leading-4 text-left">

                    <div class="text-sm font-semibold text-slate-900">
                      {{ headerProfileName }}
                    </div>

                    <div class="text-xs text-slate-500">
                      {{ headerProfileRole }}
                    </div>

                  </div>

                  <i class="fa fa-angle-down text-sm mt-1"></i>
                </button>

                <div *ngIf="profileOpen"
                  class="absolute right-24 top-10 mt-2 w-48 max-w-xs rounded bg-white shadow-lg border border-slate-200 z-9999">
                  <a class="flex items-center gap-1 px-4 py-2 pt-3 text-sm text-slate-700 hover:bg-slate-50 text-deco-none text-dark"
                    routerLink="/profile" (click)="closeProfile()">
                    <i class="fa fa-user w-5 text-slate-500 text-dark"></i>
                    Profile
                  </a>

                  <a class="flex items-center gap-1 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 text-deco-none text-dark"
                    routerLink="/reset-password" (click)="closeProfile()">
                    <i class="fa fa-gear w-5 text-slate-500 text-dark"></i>
                    Reset Password
                  </a>

                  <div class="border-t border-slate-100"></div>

                  <button type="button"
                    class="w-full flex items-center gap-1 px-4 py-2 text-sm text-red-600 hover:bg-red-50 pb-3"
                    (click)="Logout()">
                    <i class="fa fa-sign-out w-5"></i>
                    Logout
                  </button>
                </div>
              </div>
            </div>

          </div>
        </header>
      </div>

      <!-- CONTENT -->
      <main class="flex-1 overflow-auto pl-3 pr-1">
        <router-outlet></router-outlet>
      </main>
    </section>

  </div>
</div>

<!-- ✅ Logged-out layout -->
<ng-template #loggedOut>
  <router-outlet></router-outlet>
</ng-template>